import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowDownToLine, Loader2 } from "lucide-react";
import { api, API } from "@/lib/api";
import { Logo } from "@/components/Nav";
import { SmartScreenContent } from "@/components/SmartScreenGuide";

export default function DirectDownload() {
  const [state, setState] = useState("loading");

  useEffect(() => {
    api
      .get("/settings")
      .then(({ data }) => {
        const p = data.portal;
        if (p?.type === "file") {
          setState("downloading");
          window.location.replace(`${API}/portal/download`);
        } else if (p?.type === "url") {
          setState("redirecting");
          window.location.replace(p.url);
        } else {
          setState("none");
        }
      })
      .catch(() => setState("error"));
  }, []);

  const messages = {
    loading: "Preparing your download...",
    downloading: "Your download has started. If it hasn't, use the button below.",
    redirecting: "Redirecting you to the download...",
    none: "The portal setup is not published yet. Please check back shortly.",
    error: "Something went wrong. Please try again later.",
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#070F1E] px-5 text-center">
      <Logo className="h-16" />
      <div className="mt-10 flex flex-col items-center gap-4">
        {state === "loading" || state === "downloading" || state === "redirecting" ? (
          state === "loading" ? (
            <Loader2 className="h-8 w-8 animate-spin text-[#0066FF]" data-testid="download-spinner" />
          ) : (
            <ArrowDownToLine className="h-10 w-10 text-[#00F0FF]" data-testid="download-active-icon" />
          )
        ) : null}
        <p className="font-display text-xl font-bold text-white" data-testid="download-status-message">
          {messages[state]}
        </p>
        {state === "downloading" && (
          <>
            <a
              data-testid="download-retry-link"
              href={`${API}/portal/download`}
              className="rounded-full bg-[#0066FF] px-6 py-3 text-sm font-semibold text-white hover:bg-[#0052cc]"
            >
              Download again
            </a>
            <div className="mt-8 w-full max-w-lg rounded-2xl border border-[#0066FF]/25 bg-[#0B172A] p-6 text-left sm:p-8" data-testid="download-inline-guide">
              <SmartScreenContent />
            </div>
          </>
        )}
        {(state === "none" || state === "error") && (
          <Link to="/" className="rounded-full border border-slate-600 px-6 py-3 text-sm font-semibold text-slate-200 hover:border-[#00F0FF] hover:text-[#00F0FF]">
            Back to portbridge-global.com
          </Link>
        )}
      </div>
    </div>
  );
}
